import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

import { IInstallation } from '../../../../types/installation'
import { updateInstallation, fetchInstallations } from '../../../../store/installations/actions'
import { Edit } from './Edit'
import { IEditDispatchProps } from './types'
import { IStateProps } from '../types'
import { IState } from '../../../../store/types'

const mapStateToProps = (state: IState): IStateProps => {
  return {
    installations: state.installations
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IEditDispatchProps => {
  return {
    fetchInstallations: () => {
      return dispatch(fetchInstallations())
    },
    updateInstallation: (installation: IInstallation) => {
      return dispatch(updateInstallation(installation))
    }
  }
}

const EditContainer = connect(mapStateToProps, mapDispatchToProps)(Edit)

export {
  EditContainer
}
